/**
 * This object is composed of references to strings that match names of
 * possible `product_type` values represented on Shopify products
 *
 */

export default {
  'Ice Cream': 'Ice Cream',
  ICE_CREAM: 'Ice Cream',
  Events: 'Events',
  EVENTS: 'Events',
  Classes: 'Classes',
  CLASSES: 'Classes',
  'Party Deposit': 'Party Deposit',
  PARTY_DEPOSIT: 'Party Deposit',
  Merch: 'Merch',
  MERCH: 'Merch',
  CAKE_DEPOSIT: 'Cake Deposit',
  'Cake Deposit': 'Cake Deposit'
};



// WEBPACK FOOTER //
// ./src/constants/ShopifyProductTypes.js